module.exports = "/static-assets/_next/static/images/tracksuit-18104688511451c2ae05cd31e58ec759.jpg";